<template>
    <section
        class="ProductFeatured my-large palm-mb-medium palm-pb-small"
    >
        <div class="container">
            <BaseHeading
                v-if="heading && preheading"
                :heading="heading"
                :preheading="preheading"
                tag="h2"
                class="BaseHeading--default"
            />
            <BaseHeading
                v-if="!heading && preheading"
                :preheading="preheading"
                class="BaseHeading--fancy"
            />
            <BaseHeading
                v-if="heading && !preheading"
                :heading="heading"
                tag="h2"
                class="BaseHeading--default"
            />
            <div class="grid grid--medium">
                <div
                    v-for="item in items"
                    :key="item.id"
                    class="grid__item palm-one-whole one-half"
                >
                    <ProductCard
                        :product="item"
                        :subcategory="getItemSubcategory(item.subcategory)"
                        tag="h5"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ProductCard from '@components/ProductCard.vue'

export default {
    name: 'ProductFeatured',
    components: {
        ProductCard,
    },
    props: {
        items: {
            type: Array,
            default: null
        },
        preheading:{
            type: String,
            default: null
        },
        heading:{
            type: String,
            default: null
        },
        hideCategory: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getItemSubcategory(subcategory) {
            return !this.hideCategory ? subcategory : null;
        }
    }
}
</script>
<style lang="scss" scoped>

    .ProductCard {
        @include media-query('palm') {
            display: block;
            margin-bottom: getSpacing('medium');
        }

        .grid__item:last-child & {
            margin-bottom: 0!important;
        }
    }

    .BaseHeading--default {
        text-align: center;
        margin-bottom: getSpacing('small');

        @include media-query(desk) {
            margin-bottom: getSpacing('base');
        }
    }

</style>
